export const SOCIAL_TARIFF_RULE = {
  label: 'Social',
  fixed_fee: 9.01,
  bands: [
    { from: 0, to: 10, water: 3.65, sewer: 2.56 },
    { from: 10, to: 15, water: 3.65, sewer: 2.56 },
    { from: 15, to: 20, water: 3.65, sewer: 2.56 },
    { from: 20, to: 25, water: 11.57, sewer: 8.10 },
    { from: 25, to: 30, water: 14.23, sewer: 9.96 },
    { from: 30, to: 50, water: 17.02, sewer: 11.91 },
    { from: 50, to: null, water: 18.75, sewer: 13.13 },
  ],
} as const

const LEGACY_SOCIAL_BANDS = [
  { from: 0, to: 20, water: 3.65, sewer: 2.56 },
  { from: 20, to: null, water: 3.65, sewer: 2.56 },
] as const

export function normalizeSocialEconomies(value: number) {
  return Number.isFinite(value) && value > 0 ? 1 : 0
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

function sameNumber(value: unknown, expected: number) {
  return typeof value === 'number' && Math.abs(value - expected) < Number.EPSILON
}

function isLegacySocialRule(value: unknown) {
  if (!isRecord(value) || !sameNumber(value.fixed_fee, 9.01)) return false
  const bands = value.bands
  if (!Array.isArray(bands) || bands.length !== LEGACY_SOCIAL_BANDS.length) return false

  return LEGACY_SOCIAL_BANDS.every((expected, index) => {
    const current = bands[index]
    if (!isRecord(current)) return false
    const sameTo = expected.to === null ? current.to === null : sameNumber(current.to, expected.to)
    return sameNumber(current.from, expected.from)
      && sameTo
      && sameNumber(current.water, expected.water)
      && sameNumber(current.sewer, expected.sewer)
  })
}

export function applySocialTariffRule<T extends { payload: Record<string, unknown> }>(config: T): T {
  const payload = config.payload as Record<string, unknown> & { categories?: Record<string, unknown> }
  const categories = payload.categories
  if (!categories || !isLegacySocialRule(categories.social)) return config

  return {
    ...config,
    payload: {
      ...payload,
      categories: {
        ...categories,
        social: SOCIAL_TARIFF_RULE,
      },
    },
  }
}
